import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { RolesService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class RoleBloc extends Bloc<RolesService['roleControllerGetOne']> {
    public constructor(service: RolesService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.roleControllerGetOne.bind(service), {
            debug: debug ?? false,
        });
    }
}
